import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { trigger, state, style, transition, animate, query, stagger, keyframes } from '@angular/animations';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/flex-layout/flex';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/flex-layout/extended';
import * as ɵngcc5 from '@angular/material/icon';
import * as ɵngcc6 from '@angular/material/tooltip';

function MatFabMenuComponent_div_5_button_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fab_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("color", fab_r2 == null ? null : fab_r2.iconColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(fab_r2 == null ? null : fab_r2.icon);
} }
function MatFabMenuComponent_div_5_button_1_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 10);
} if (rf & 2) {
    const fab_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("src", fab_r2 == null ? null : fab_r2.imgUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
const _c0 = function (a0) { return { "fullSVG": a0 }; };
function MatFabMenuComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function MatFabMenuComponent_div_5_button_1_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const fab_r2 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.selectFabMenu(fab_r2); });
    ɵngcc0.ɵɵtemplate(1, MatFabMenuComponent_div_5_button_1_mat_icon_1_Template, 2, 2, "mat-icon", 7);
    ɵngcc0.ɵɵtemplate(2, MatFabMenuComponent_div_5_button_1_img_2_Template, 1, 1, "img", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fab_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("color", fab_r2 == null ? null : fab_r2.color)("matTooltip", fab_r2 == null ? null : fab_r2.tooltip)("matTooltipPosition", fab_r2 == null ? null : fab_r2.tooltipPosition)("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c0, fab_r2 == null ? null : fab_r2.imgUrl));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", fab_r2 == null ? null : fab_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", fab_r2 == null ? null : fab_r2.imgUrl);
} }
function MatFabMenuComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, MatFabMenuComponent_div_5_button_1_Template, 3, 8, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@fabsStagger", ctx_r0.fabButtons.length)("fxLayout", ctx_r0.layout2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.fabButtons);
} }
const _c1 = function (a0, a1) { return { "mat-fab": a0, "mat-mini-fab": a1 }; };
const _c2 = function (a0) { return { value: a0 }; };
const speedDialFabAnimations = [
    trigger('fabToggler', [
        state('false', style({
            transform: 'rotate(0deg)'
        })),
        state('true', style({
            transform: 'rotate(225deg)'
        })),
        transition('* <=> *', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fabsStagger', [
        transition('* => *', [
            query(':enter', style({ opacity: 0 }), { optional: true }),
            query(':enter', stagger('40ms', [
                animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', keyframes([
                    style({ opacity: 0, transform: 'translateY(10px)' }),
                    style({ opacity: 1, transform: 'translateY(0)' }),
                ]))
            ]), { optional: true }),
            query(':leave', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', keyframes([
                style({ opacity: 1 }),
                style({ opacity: 0 }),
            ])), { optional: true })
        ])
    ])
];

class MatFabMenuComponent {
    constructor() {
        this.icon = 'add';
        this.direction = 'top';
        this.color = 'accent';
        this.closeAfterSelection = true;
        // tslint:disable-next-line:no-output-on-prefix
        this.onFabMenuItemSelected = new EventEmitter();
    }
    ngOnInit() {
        this.adjustLayout();
    }
    ngOnChanges(changes) {
        if (changes.direction && !changes.direction.firstChange) {
            this.direction = changes.direction.currentValue;
            this.adjustLayout();
        }
        if (changes.color && !changes.color.firstChange) {
            this.color = changes.color.currentValue;
        }
        if (changes.fabButtons && !changes.fabButtons.firstChange) {
            this.fabButtons = changes.fabButtons.currentValue;
        }
    }
    adjustLayout() {
        switch (this.direction) {
            case 'top':
                this.layout = 'column-reverse';
                this.layout2 = 'column-reverse';
                break;
            case 'bottom':
                this.layout = 'column';
                this.layout2 = 'column';
                break;
            case 'left':
                this.layout = 'row-reverse';
                this.layout2 = 'row-reverse';
                break;
            case 'right':
                this.layout = 'row';
                this.layout2 = 'row';
                break;
        }
    }
    toggle() {
        this.isActive = !this.isActive;
    }
    selectFabMenu(fab) {
        this.onFabMenuItemSelected.emit(fab.id);
        if (this.closeAfterSelection) {
            this.isActive = false;
        }
    }
}
MatFabMenuComponent.ɵfac = function MatFabMenuComponent_Factory(t) { return new (t || MatFabMenuComponent)(); };
MatFabMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MatFabMenuComponent, selectors: [["mat-fab-menu"]], inputs: { icon: "icon", direction: "direction", color: "color", closeAfterSelection: "closeAfterSelection", fabButtons: "fabButtons", isActive: "isActive", disabled: "disabled" }, outputs: { onFabMenuItemSelected: "onFabMenuItemSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 12, consts: [["fxLayoutAlign", "center center", "fxLayoutGap", "16px", 1, "container", 3, "fxLayout"], ["fxLayoutAlign", "center"], ["type", "button", "mat-fab", "", 3, "color", "disabled", "ngClass", "click"], ["fxLayoutAlign", "center center", "fxLayoutGap", "16px", 3, "fxLayout", 4, "ngIf"], ["fxLayoutAlign", "center center", "fxLayoutGap", "16px", 3, "fxLayout"], ["type", "button", "mat-fab", "", 3, "color", "matTooltip", "matTooltipPosition", "ngClass", "click", 4, "ngFor", "ngForOf"], ["type", "button", "mat-fab", "", 3, "color", "matTooltip", "matTooltipPosition", "ngClass", "click"], [3, "color", 4, "ngIf"], ["alt", "icon", 3, "src", 4, "ngIf"], [3, "color"], ["alt", "icon", 3, "src"]], template: function MatFabMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function MatFabMenuComponent_Template_button_click_2_listener() { return ctx.isActive = !ctx.isActive; });
        ɵngcc0.ɵɵelementStart(3, "mat-icon");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, MatFabMenuComponent_div_5_Template, 2, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("fxLayout", ctx.layout);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("color", ctx.color)("disabled", ctx.disabled)("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c1, !ctx.isActive, ctx.isActive));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("@fabToggler", ɵngcc0.ɵɵpureFunction1(10, _c2, ctx.isActive));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActive);
    } }, directives: [ɵngcc1.DefaultLayoutAlignDirective, ɵngcc1.DefaultLayoutGapDirective, ɵngcc1.DefaultLayoutDirective, ɵngcc2.MatButton, ɵngcc3.NgClass, ɵngcc4.DefaultClassDirective, ɵngcc5.MatIcon, ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc6.MatTooltip], styles: ["[_nghost-%COMP%]{display:block}.fullSVG[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.fullSVG[_ngcontent-%COMP%]     span.mat-button-wrapper{padding:0}.container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-bottom:5px}.container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-bottom:16px}"], data: { animation: speedDialFabAnimations } });
MatFabMenuComponent.ctorParameters = () => [];
MatFabMenuComponent.propDecorators = {
    fabButtons: [{ type: Input }],
    icon: [{ type: Input }],
    direction: [{ type: Input }],
    color: [{ type: Input }],
    isActive: [{ type: Input }],
    disabled: [{ type: Input }],
    closeAfterSelection: [{ type: Input }],
    onFabMenuItemSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatFabMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mat-fab-menu',
                template: "<div [fxLayout]=\"layout\" class=\"container\" fxLayoutAlign=\"center center\" fxLayoutGap=\"16px\">\n  <div fxLayoutAlign=\"center\">\n    <button (click)=\"isActive = !isActive\"\n            [color]=\"color\" [disabled]=\"disabled\"\n            type=\"button\"\n            [ngClass]=\"{\n    'mat-fab' : !isActive,\n    'mat-mini-fab' : isActive\n  }\"\n            mat-fab>\n      <mat-icon [@fabToggler]=\"{value: isActive}\">{{icon}}</mat-icon> <!-- Animation here -->\n    </button>\n  </div>\n  <div *ngIf=\"isActive\" [@fabsStagger]=\"fabButtons.length\"\n       [fxLayout]=\"layout2\" fxLayoutAlign=\"center center\" fxLayoutGap=\"16px\">\n    <button (click)=\"selectFabMenu(fab)\"\n            *ngFor=\"let fab of fabButtons\"\n            [color]=\"fab?.color\"\n            [matTooltip]=\"fab?.tooltip\"\n            [matTooltipPosition]=\"fab?.tooltipPosition\"\n            [ngClass]=\"{'fullSVG' : fab?.imgUrl}\"\n            type=\"button\"\n            mat-fab>\n      <mat-icon *ngIf=\"fab?.icon\" [color]=\"fab?.iconColor\">{{fab?.icon}}</mat-icon>\n      <img *ngIf=\"fab?.imgUrl\" [src]=\"fab?.imgUrl\" alt=\"icon\">\n    </button>\n  </div>\n</div>\n",
                animations: speedDialFabAnimations,
                styles: [":host{display:block}.fullSVG img{width:100%}.fullSVG ::ng-deep span.mat-button-wrapper{padding:0}.container>div{margin-bottom:5px}.container>div button{margin-bottom:16px}"]
            }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], direction: [{
            type: Input
        }], color: [{
            type: Input
        }], closeAfterSelection: [{
            type: Input
        }], onFabMenuItemSelected: [{
            type: Output
        }], fabButtons: [{
            type: Input
        }], isActive: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class MatFabMenuModule {
}
MatFabMenuModule.ɵfac = function MatFabMenuModule_Factory(t) { return new (t || MatFabMenuModule)(); };
MatFabMenuModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MatFabMenuModule });
MatFabMenuModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatButtonModule,
            MatIconModule,
            MatTooltipModule,
            FlexLayoutModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatFabMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [MatFabMenuComponent],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatIconModule,
                    MatTooltipModule,
                    FlexLayoutModule
                ],
                exports: [MatFabMenuComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MatFabMenuModule, { declarations: function () { return [MatFabMenuComponent]; }, imports: function () { return [CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        FlexLayoutModule]; }, exports: function () { return [MatFabMenuComponent]; } }); })();

/*
 * Public API Surface of fab-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MatFabMenuComponent, MatFabMenuModule, speedDialFabAnimations as ɵa };

